var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.wrapperClass},[_vm._t("default"),(_vm.showErrorMessage)?_c('p',{class:_vm.messageClass,domProps:{"innerHTML":_vm._s(_vm.currentErrorMessageContents)}}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }